module.exports = __webpack_public_path__ + "static/snowball-app-stock-financial-frame-f53c6f1bd9f54816ccc23867c6277e34.png";